import { isEmpty } from 'lodash'
import newGifFetcher from 'shared/redux/fetch-new-gifs'
import gifShareAnalytics from 'shared/redux/gif-share-analytics'
import { autoPlay } from 'shared/redux/auto-play'
import { receivedGifs } from 'shared/redux/gifs'
import { resetNewGifs } from 'shared/redux/new-gifs'
import * as reducers from 'shared/redux/reducers'

export function toggleAutoPlay() {
    return function(dispatch, getState) {
        const state = getState()
        const isAutoplayOn = reducers.getAutoPlay(state)
        return dispatch(autoPlay(!isAutoplayOn))
    }
}

export function trackShare(id, type) {
    return function() {
        return gifShareAnalytics(id, type)
    }
}

export function checkForNewGifs(channelId) {
    return function(dispatch, getState) {
        const state = getState()
        const isPolling = reducers.getPolling(state)
        const currentGifIds = reducers.getGifIds(state)

        if (isEmpty(currentGifIds) || isPolling) {
            return Promise.resolve()
        }

        return newGifFetcher(channelId, currentGifIds)(dispatch)
    }
}

export function showNewGifs(groupId) {
    return function(dispatch, getState) {
        const state = getState()
        const newGifs = reducers.getNewGifs(state)
        const { pagination } = state

        if (!newGifs.length) {
            return Promise.resolve()
        }

        dispatch(resetNewGifs())
        dispatch(
            receivedGifs({
                gifs: newGifs,
                prepend: true,
                groupId: groupId,
                nextUrl: pagination.nextUrl,
            }),
        )

        return newGifs
    }
}
